import { gql, useQuery } from '@apollo/client';
import { APPLICATION_FIELDS, QUESTIONNAIRE_FIELDS, TOPIC_FIELDS } from '@dieterApi/topic/useTopicsQuery';
import { GetUserInput, UserTopicApplicationsQuestionnaires } from './useUserQuery';

export const GET_USER_TENANTS = gql`
  ${TOPIC_FIELDS}
  ${APPLICATION_FIELDS}
  ${QUESTIONNAIRE_FIELDS}

  query GetUserTenants($userId: String) {
    getUser(userId: $userId) {
      id
      companies {
        id
        name
        topics {
          ...UserTopicFields
          applications {
            ...UserAppFields
            questionnaires {
              ...UserQuestionnaireFields
            }
          }
        }
      }
    }
  }
`;

interface GetUserTenantsOutput {
  getUser: {
    id: string;
    companies: ({ id: string; name: string } & { topics: UserTopicApplicationsQuestionnaires[] })[];
  };
}

export function useUserTenantsQuery() {
  return useQuery<GetUserTenantsOutput, GetUserInput>(GET_USER_TENANTS, {
    fetchPolicy: 'no-cache',
  });
}
